"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Copyright = void 0;
var react_1 = __importDefault(require("react"));
var defaultRootStyle = {
    fontSize: 12,
    display: 'flex',
    zIndex: 999
};
var defaultLinkStyle = {
    textDecoration: 'none'
};
var Copyright = function (_a) {
    var rootStyleOverride = _a.rootStyleOverride, linkStyleOverride = _a.linkStyleOverride;
    var rootStyle = __assign(__assign({}, defaultRootStyle), rootStyleOverride);
    var linkStyle = __assign(__assign({}, defaultLinkStyle), linkStyleOverride);
    return (react_1.default.createElement("span", { style: rootStyle },
        react_1.default.createElement("a", { href: "https://www.icos-ri.eu/", target: "_blank", style: linkStyle }, "\u00A9 ICOS RI"),
        react_1.default.createElement("span", null, "\u00A0-\u00A0"),
        react_1.default.createElement("a", { rel: "license", href: "http://creativecommons.org/licenses/by/4.0/", target: "_blank" },
            react_1.default.createElement("img", { alt: "Creative Commons License", src: "//static.icos-cp.eu/images/cc4by_small.png" }))));
};
exports.Copyright = Copyright;
